@if (!loading) {
  <app-patient-header [patient]="patient" />
  <div class="mt-3"><app-patient-communications [patient]="patient" /></div>
} @else {
  <mat-spinner />
}
